import { get, pick } from 'lodash'
import { useMemo } from 'react'
import { toString } from 'utils/to-string'

export function useSelectOptions({
    options,
    optionKey,
    optionValue = 'value',
    optionLabel = 'label',
    optionTemplate,
}) {
    const result = useMemo(() => {
        const opts = options.map((option) => {
            const fields = optionValue.split(',')
            const value =
                fields.length > 1
                    ? toString(pick(option, fields))
                    : getOptionProp(option, optionValue)
            const label =
                typeof optionTemplate === 'function'
                    ? optionTemplate(option)
                    : getOptionProp(option, optionLabel)
            return {
                data: option,
                key: optionKey ? getOptionProp(option, optionKey) : value,
                value,
                label,
            }
        })
        const mapOptions = opts.reduce((carry, opt) => {
            carry[opt.key] = opt.data
            return carry
        }, {})
        return { options: opts, mapOptions }
    }, [options, optionValue, optionLabel, optionTemplate])

    return result
}

function getOptionProp(option, prop) {
    if (typeof option === 'object' && option !== null) {
        const value = prop ? get(option, prop) : option
        return toString(value)
    } else {
        return toString(option ?? '')
    }
}
